import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
    children: ReactNode;
    onCaught: (err: Error, errorInfo: ErrorInfo) => void;
}

interface State {
    hasError: boolean;
}

export class HideOnErrorBoundary extends Component<Props, State> {
    protected prevError = "";
    public state = {
        hasError: false,
    };

    public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
        console.error("Error caught by error boundary hider", error, errorInfo);

        if(this.prevError === error.toString()) {
            return;
        }

        this.props.onCaught(error, errorInfo);
        this.setState({
            hasError: true,
        });
    }

    public componentDidUpdate(prevProps: Readonly<Props>): void {
        if(prevProps.children !== this.props.children && this.state.hasError) {
            this.setState({
                hasError: false,
            });
        }
    }

    public render(): ReactNode {
        if(this.state.hasError) {
            return null;
        }

        return this.props.children;
    }
}
